import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { settingsAPI } from '../services/api'
import { useAuth } from './AuthContext'
import { DEFAULT_RUNTIME_SETTINGS, loadRuntimeSettings } from './runtimeSettingsLogic.mjs'

const Context = createContext({ settings: DEFAULT_RUNTIME_SETTINGS, loading: true, error: null, reload: () => {} })

export function RuntimeSettingsProvider({ children }) {
  const { isAuthenticated, loading: authLoading } = useAuth()
  const [state, setState] = useState({ settings: DEFAULT_RUNTIME_SETTINGS, loading: true, error: null })
  const reload = async () => {
    setState(current => ({ ...current, loading: true, error: null }))
    setState(await loadRuntimeSettings(settingsAPI.runtime))
  }
  useEffect(() => {
    if (!authLoading && isAuthenticated) reload()
    if (!authLoading && !isAuthenticated) setState({ settings: DEFAULT_RUNTIME_SETTINGS, loading: false, error: null })
  }, [authLoading, isAuthenticated])
  const value = useMemo(() => ({ ...state, reload }), [state])
  return <Context.Provider value={value}>{children}</Context.Provider>
}
export const useRuntimeSettings = () => useContext(Context)
